
import { config } from '@/config'
import { toJS } from 'mobx'
//搜索的方法
const searchFun = (values) => {
  let newValues = JSON.parse(JSON.stringify(values))
  for (let attr in newValues) {
    if (newValues[attr] !== undefined) {
      if (newValues[attr] !== null) {
        if (newValues[attr].indexOf('+-+') !== -1) {
          newValues[attr] = "RANGE"
        } else {
          newValues[attr] = "="
        }
      } else {
        newValues[attr] = "RANGE"
      }
    }
  }
  delete newValues.select
  delete newValues.keyword
  let newData = { [values.select]: values.keyword }
  let newDataValues = JSON.parse(JSON.stringify(newData))

  for (let i in newDataValues) {
    if (newDataValues[i] !== undefined) {
      newDataValues[i] = "LIKE";
    }
  }
  delete values.select
  delete values.keyword
  let content = { ...values, ...newData }
  let rule = { ...newValues, ...newDataValues }
  return { content, rule }
}

//字典回显
const workData = (val) => {
  let data = [];
  val.forEach((item) => {
    for (let attr in item) {
      let newdata = {}
      newdata.value = attr
      newdata.label = item[attr]
      data.push(newdata)
    }
  })
  return data
}

/////图片

//图片上传
const toarrayImg = (value) => {
  let imgsa = []
  let imgsb = ''
  value.forEach((item) => {
    imgsa = imgsa.concat(item.urlb)
  })
  imgsb = imgsa.join(",")
  return imgsb
}
//oss图片上传
const tonewImg = (value) => {
  let imgsa = []
  let imgsb = ''
  value.forEach((item) => {
    imgsa = imgsa.concat(item.url)
  })
  imgsb = imgsa.join(",")
  return imgsb
}


//图片回显
const echoImg = (value) => {
  let imglist = []
  if (typeof value == 'string') {
    value = value.split(',')
    value.forEach((item) => {
      imglist = imglist.concat({ url: config.apihost + item, urlb: item, name: item })
    })
  } else {
    imglist = value
  }
  return imglist
}
//oss图片回显
const echonewImg = (value) => {
  let imglist = []
  if (typeof value == 'string') {
    value = value.split(',')
    value.forEach((item) => {
      imglist = imglist.concat({ url: item, urlb: item, name: item })
    })
  } else {
    imglist = value
  }
  return imglist
}


////视频
//处理视频上传
const upVideo = (value) => {
  let imgsa = []
  let imgsb = ''
  value.forEach((item) => {
    item.url = item.url.split('?')[0]
    imgsa = imgsa.concat(item.url)
  })
  imgsb = imgsa.join(",")
  return imgsb
}

const upVideoOther = (value) => {
  let imgsa = []
  let imgsb = ''
  value.forEach((item) => {
    imgsa = imgsa.concat(item.urlb)
  })
  imgsb = imgsa.join(",")
  return imgsb
}


//视频回显
const echoVideo = (value) => {
  let newValues = value.split('.com')
  let imglist = []
  if (typeof newValues[1] == 'string') {
    newValues[1] = newValues[1].split(',')
    newValues[1].forEach((item) => {
      imglist = imglist.concat({ url: 'http://kaili-liveshop.oss-cn-qingdao.aliyuncs.com' + item + '?x-oss-process=video/snapshot,t_0,f_jpg,w_400,h_300,m_fast', urlb: item, name: item })
    })
  } else {
    imglist = value
  }
  return imglist
}



const echoImg02 = (value) => {
  let imglist = []
  if (typeof value == 'string') {
    value = value.split(',')
    value.forEach((item) => {
      imglist = imglist.concat({ url: item, urlb: item, name: item })
    })
  } else {
    imglist = value
  }
  return imglist
}
function htmlEscape(str) { //字符转义
  var escapesMap = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  },
    reUnescapedHtml = new RegExp(/[<>"']/g);
  return (str && reUnescapedHtml.test(str)) ? str.replace(reUnescapedHtml, function (chr) {
    return escapesMap[chr];
  }) : (str || "");
}

function htmlUnEscape(str) { //反转义
  var unescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  },
    reEscapedHtml = new RegExp(/&(?:amp|lt|gt|quot|#39);/g);
  return (str && reEscapedHtml.test(str)) ? str.replace(reEscapedHtml, function (entity) {
    return unescapes[entity];
  }) : (str || '')
}



export { searchFun, workData, toarrayImg, echoImg, upVideo, echoVideo, upVideoOther, tonewImg, echonewImg, echoImg02, htmlEscape, htmlUnEscape }